<template>
  <l-popup icon="bars" placement="right-start" class="text-lg">
    <div class="text-sm flex flex-wrap w-64 select-none pb-2 pt-2">
      <router-link
        v-close-popover
        :to="a.to"
        class="px-4 py-2 w-full hover:bg-blue-100 hover:cursor-pointer"
        :class="{'border-b border-gray-light': a.border }"
        v-for="(a, i) in menu_sub"
        :key="i"
        v-if="me.permissions.includes(a.permission)"
      >
        <font-awesome-icon :icon="a.icon" :class="a.class" />
        <label class="ml-2 select-none hover:cursor-pointer">{{a.text}}</label>
      </router-link>
    </div>
  </l-popup>
</template>



<script>
import LPopup from "@/components/LPopup";
import { VClosePopover } from "v-tooltip";
import UsersService from "@/helpers/services/users.service";

export default {
  name: "LMenu",
  components: {
    LPopup
  },
  directives: {
    "close-popover": VClosePopover
  },
  data() {
    return {
      me: { permissions: [] },
      menu_sub: [
        {
          permission: UsersService.permissions().users,
          icon: "network-wired",
          class: "text-pastel-purple",
          text: "Responsible authorities",
          to: "/management/responsible_authorities"
        },
        {
          permission: UsersService.permissions().network,
          icon: "network-wired",
          class: "text-pastel-purple",
          text: "Networks",
          to: "/management/networks"
        },
        {
          permission: UsersService.permissions().network,
          icon: "network-wired",
          class: "text-pastel-purple",
          text: "Stations",
          to: "/management/stations"
        },
        {
          permission: UsersService.permissions().observations,
          icon: "network-wired",
          class: "text-pastel-purple",
          text: "Sampling points",
          to: "/management/samplingpoints"
        },
        {
          permission: UsersService.permissions().network,
          icon: "network-wired",
          class: "text-pastel-purple",
          text: "Processes",
          to: "/management/processes"
        },
        {
          permission: UsersService.permissions().observations,
          icon: "network-wired",
          class: "text-pastel-purple",
          text: "Samples",
          to: "/management/samples"
        },
        {
          permission: UsersService.permissions().observations,
          icon: "network-wired",
          class: "text-pastel-purple",
          text: "Observing capabilities",
          to: "/management/observing_capabilities"
        },
        {
          permission: UsersService.permissions().observations,
          icon: "network-wired",
          class: "text-pastel-purple",
          text: "Observations",
          to: "/management/observations",
        },
        {
          permission: UsersService.permissions().network,
          icon: "network-wired",
          class: "text-pastel-purple",
          text: "Assessment regime",
          to: "/management/assessment_regimes",
        },  
        {
          permission: UsersService.permissions().network,
          icon: "network-wired",
          class: "text-pastel-purple",
          text: "Attainment",
          to: "/management/attainments",
        }, 
        {
          permission: UsersService.permissions().network,
          icon: "network-wired",
          class: "text-pastel-purple",
          text: "Exceedance Descriptions",
          to: "/management/exceedance_descriptions",
          border: true
        },         
        {
          permission: UsersService.permissions().observations,
          icon: "chart-bar",
          class: "text-pastel-red",
          text: "Historical data",
          to: "/viewer/historical",
          border: true
        },             
        {
          permission: UsersService.permissions().exporting,
          icon: "file-export",
          class: "text-blue-400",
          text: "Dataflows",
          to: "/export",
          border: true
        },
        {
          permission: UsersService.permissions().processing,
          icon: "stream",
          class: "text-pastel-green-500",
          text: "Scaled timeseries",
          to: "/processing/scaling",
        },  
        {
          permission: UsersService.permissions().processing,
          icon: "stream",
          class: "text-pastel-green-500",
          text: "Calculated timeseries",
          to: "/processing/calculated",
        },
        {
          permission: UsersService.permissions().processing,
          icon: "stream",
          class: "text-pastel-green-500",
          text: "Converted timeseries",
          to: "/processing/converted",
          border: true
        },
        {
          permission: UsersService.permissions().qualitycontrol,
          icon: "clipboard-check",
          class: "text-pastel-orange",
          text: "Validate",
          to: "/qualitycontrol/validate"
        },
        {
          permission: UsersService.permissions().qualitycontrol,
          icon: "clipboard-check",
          class: "text-pastel-orange",
          text: "Verify",
          to: "/qualitycontrol/verify",
          border: true
        }, 
        {
            permission: UsersService.permissions().users,
            icon: "users-cog",
            class: "text-bluegray-200",
            text: "Users",
            to: "/users/edit"
        },
        {
            permission: UsersService.permissions().users,
            icon: "user-tag",
            class: "text-bluegray-200",
            text: "Groups",
            to: "/users/groups"
        }
      ]
    };
  },
    async created() {
        try {          
            this.me = await UsersService.me();
        } catch (e) {}
    }
};
</script>

